import { CustomEventDetailTrackViewData, TealiumData } from "../types";

export const CUSTOM_EVENT_TRACK_VIEW_DATA = "@argonaut/analytics/trackViewData";

export const trackViewData = (viewData: TealiumData): void => {
  if (typeof document === "object") {
    document.dispatchEvent(
      new CustomEvent<CustomEventDetailTrackViewData>(
        CUSTOM_EVENT_TRACK_VIEW_DATA,
        {
          detail: { viewData },
        },
      ),
    );
  }
};
